import { types } from 'mobx-state-tree'

const { model } = types

const EMPTY_TOAST = {
  open: false,
  severity: null,
  message: null,
  // Rendered after the message as a clickable link inside the toast.
  actionLabel: null,
  onAction: null,
  autoHideDuration: null,
}

/**
 * App-wide toast notification state.
 *
 * Kept volatile because `onAction` is a callback and a toast never needs to survive a
 * snapshot. Records are replaced wholesale rather than mutated so observers always see
 * the change.
 */
const Toast = model({})
  .volatile(() => ({
    toast: EMPTY_TOAST,
  }))
  .actions(self => ({
    /**
     * @param {object} params
     * @param {'success'|'error'|'warning'|'info'} params.severity
     * @param {string} params.message
     * @param {string} [params.actionLabel] Label for the toast's inline link.
     * @param {function} [params.onAction] Invoked when the toast or its link is clicked.
     * @param {number} [params.autoHideDuration] Milliseconds; defaults to 6000 in the view.
     */
    showToast({ severity, message, actionLabel, onAction, autoHideDuration }) {
      self.toast = {
        open: true,
        severity,
        message,
        actionLabel: actionLabel ?? null,
        onAction: onAction ?? null,
        autoHideDuration: autoHideDuration ?? null,
      }
    },

    hideToast() {
      // Keep severity so the alert does not flash a different color while it animates out.
      self.toast = { ...self.toast, open: false }
    },
  }))

export default Toast
